import { Controller } from "@hotwired/stimulus"

// Auto-submits the Watchlist filter form when a dropdown changes
// so filters feel immediate — no "click Apply" needed for selects.
// The text search still requires explicit submit / Enter.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
